// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2ZLU6","head":"Item_head__1KwZ7","active":"Item_active__rF-ET","body":"Item_body__2rC2F","title":"Item_title__eKEGc"};